import React from 'react'
import { Link } from 'gatsby'
import { skipNoReferrer } from '../utils/url_helpers'
import { useSiteMetadata } from '../hooks/useSiteMetadata'

const ExternalLink = ({
  children,
  href,
}: {
  children: JSX.Element
  href: string
}) => {
  const { pathPrefix } = useSiteMetadata()

  if (href[0] === '/') {
    // Remove duplicate path prefix from href, added once by MDXProvider and second time by Gatsby Link
    return (
      <Link
        to={href.replace(pathPrefix, '')}
        className="underline text-primary-600 font-semibold border-0"
      >
        {children}
      </Link>
    )
  }
  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      href={href}
      target="_blank"
      rel={`noopener ${skipNoReferrer(href) ? '' : 'noreferrer'}`}
      className="underline text-primary-600 font-semibold border-0"
    >
      {children}
    </a>
  )
}

export default ExternalLink
